import React, { useState } from 'react';
import { useNotifications } from '../../contexts/notificationContext';
import Button from '../bootstrap/Button';
import NotificationPanel from './NotificationPanel';

/**
 * NotificationBell — Icon bell di header dengan badge merah.
 * Klik untuk membuka NotificationPanel (OffCanvas).
 */
const NotificationBell: React.FC = () => {
  const { unreadCount } = useNotifications();
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  return (
    <>
      <Button
        aria-label="Notifications"
        color="primary"
        isLight
        className="position-relative"
        icon="Notifications"
        onClick={() => setIsPanelOpen(true)}
      >
        {unreadCount > 0 && (
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
            style={{ fontSize: '0.65rem', minWidth: '18px' }}
          >
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </Button>

      {isPanelOpen && (
        <NotificationPanel onClose={() => setIsPanelOpen(false)} />
      )}
    </>
  );
};

export default NotificationBell;
